import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerHelper } from '../../../../helpers/spinner.helper';
import { ToastrHelper } from '../../../../helpers/toastr.helper';
import { Project } from '../../../../models/projects/project.model';
import { AccountsService } from '../../../../services/identity/accounts.service';
import { ProjectsService } from '../../../../services/projects/projects.service';

@Component({
    selector: 'dialog-cancel-join-project',
    template: `
        <p-dialog
            header="{{ 'projects.modals.cancelJoin.title' | translate }}"
            [(visible)]="visible"
            [modal]="true"
            [draggable]="false"
            [resizable]="false"
        >
            <p class="">
                {{ 'projects.modals.cancelJoin.message' | translate }}
            </p>
            <p-footer>
                <button pButton class="p-button-text" (click)="closeModal()">
                    {{ 'projects.modals.cancelJoin.cancel' | translate }}
                </button>
                <button pButton (click)="cancelJoinProject()">
                    {{ 'projects.modals.cancelJoin.confirm' | translate }}
                </button>
            </p-footer>
        </p-dialog>
    `,
})
export class DialogCancelJoinProjectComponent implements OnInit {
    @Output() public acted = new EventEmitter<any>();
    public isModalDisplayed: boolean;
    @Input() public project: Project;
    @Input() public visible: boolean;
    @Output() public visibleChange = new EventEmitter<boolean>();

    constructor(
        private readonly spinnerHelper: SpinnerHelper,
        private readonly translate: TranslateService,
        private readonly projectsService: ProjectsService,
        private readonly toastrHelper: ToastrHelper,
        private readonly accountsService: AccountsService,
    ) {}

    public cancelJoinProject() {
        this.spinnerHelper.showSpinner();
        this.projectsService.cancelJoinProject(this.project.id).subscribe(
            () => {
                const msg = this.translate.instant('projects.modals.cancelJoin.toast.success');
                this.toastrHelper.showSuccess(msg);
                this.project.attendees = this.project.attendees.filter((attendee) => attendee.id !== this.accountsService.currentUser.userId);
                this.acted.emit();
            },
            (error) => {
                this.toastrHelper.showGenericError(error);
            },
            () => {
                this.spinnerHelper.hideSpinner();
                this.closeModal();
            },
        );
    }

    public closeModal() {
        this.visible = false;
        this.visibleChange.emit(false);
    }

    public ngOnInit(): void {}
}
